import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {CompanyInterface} from "../interfaces/company.interface";
import {Store} from "@ngrx/store";
import {selectCompany} from "../store/store.selectors";
import {ViesCompanyInterface} from "../interfaces/vies-company.interface";

@Injectable({
    providedIn: 'root'
})
export class CompanyService {
    company: CompanyInterface;
    constructor(
        private http: HttpClient,
        private store: Store
    ) {
        this.store.select(selectCompany).subscribe(result => {
            this.company = result;
        })
    }

    getInfo() {
        return this.http.get<CompanyInterface>(`/api_company/settings/company`)
    }

    update(data) {
        return this.http.put<CompanyInterface>(`/api_company/settings/company`, data)
    }

    fetchFromGUS(taxNumber: string) {
        return this.http.post<Partial<CompanyInterface>>(`/api_company/clients/get-from-gus`, {tax_number: taxNumber})
    }

    fetchFromVies(country: string, taxNumber: string) {
        return this.http.post<ViesCompanyInterface>(`/api_company/clients/get-from-vies`, {country, tax_number: taxNumber})
    }
}
